export default __webpack_public_path__ + "static/media/quidco.1824ae78.png";